import React from "react";
import { motion } from "framer-motion";
import { Phone, MessageCircle, Mail, MapPin } from "lucide-react";
import { BRAND, WHATSAPP_URL } from "../lib/brand";

export const Contact = () => {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="section-pad bg-[#FAF8F2]"
    >
      <div className="container-luxury">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <div className="heading-eyebrow justify-center">
            <span className="line" />
            <span className="text">Trade Desk</span>
          </div>
          <h2 className="font-serif text-3xl md:text-5xl text-[#0E4D3D] leading-tight">
            Speak to a specialist.
          </h2>
          <p className="mt-4 text-[#4A4A4A] font-light">
            Three direct lines into our Bangalore office. Pick what suits you.
          </p>
        </div>

        <div className="grid lg:grid-cols-12 gap-8">
          {/* Contact cards */}
          <div className="lg:col-span-5 grid sm:grid-cols-2 lg:grid-cols-1 gap-4">
            <a
              href={`tel:${BRAND.phoneRaw}`}
              data-testid="contact-phone"
              className="group p-7 bg-white border border-[#0E4D3D]/10 hover:border-[#C9A227] transition-all lift"
            >
              <Phone className="w-7 h-7 text-[#0E4D3D] group-hover:text-[#C9A227] transition-colors" strokeWidth={1.4} />
              <div className="label-overline text-[#C9A227] mt-5">Direct Line</div>
              <div className="font-serif text-xl text-[#0E4D3D] mt-1">
                {BRAND.phone}
              </div>
              <div className="text-[#4A4A4A] text-sm mt-1 font-light">
                Mon – Sat · 9 AM – 7 PM
              </div>
            </a>

            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-whatsapp"
              className="group p-7 bg-[#0E4D3D] text-white hover:bg-[#C9A227] hover:text-[#0E4D3D] transition-all lift"
            >
              <MessageCircle className="w-7 h-7 text-[#C9A227] group-hover:text-[#0E4D3D] transition-colors" strokeWidth={1.4} />
              <div className="label-overline text-[#C9A227] mt-5 group-hover:text-[#0E4D3D]">
                Instant Reply
              </div>
              <div className="font-serif text-xl mt-1">
                WhatsApp Trade Desk
              </div>
              <div className="text-white/70 group-hover:text-[#0E4D3D]/80 text-sm mt-1 font-light">
                Quotes · Samples · Price list
              </div>
            </a>

            <a
              href={`mailto:${BRAND.email}`}
              data-testid="contact-email"
              className="group p-7 bg-white border border-[#0E4D3D]/10 hover:border-[#C9A227] transition-all lift"
            >
              <Mail className="w-7 h-7 text-[#0E4D3D] group-hover:text-[#C9A227] transition-colors" strokeWidth={1.4} />
              <div className="label-overline text-[#C9A227] mt-5">Email</div>
              <div className="font-serif text-xl text-[#0E4D3D] mt-1 break-all">
                {BRAND.email}
              </div>
              <div className="text-[#4A4A4A] text-sm mt-1 font-light">
                Responds within one business hour
              </div>
            </a>

            <div className="p-7 bg-white border border-[#0E4D3D]/10 lift">
              <MapPin className="w-7 h-7 text-[#0E4D3D]" strokeWidth={1.4} />
              <div className="label-overline text-[#C9A227] mt-5">Office</div>
              <div className="font-serif text-lg text-[#0E4D3D] mt-1 leading-snug">
                {BRAND.address.line1}
              </div>
              <div className="text-[#4A4A4A] text-sm font-light">
                {BRAND.address.line2}
                <br />
                {BRAND.address.city}
              </div>
            </div>
          </div>

          {/* Map */}
          <motion.div
            initial={{ opacity: 0, scale: 0.96 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="lg:col-span-7"
          >
            <div className="relative h-full min-h-[400px] bg-white border border-[#0E4D3D]/10 overflow-hidden">
              <iframe
                title="Office location"
                src={BRAND.mapEmbed}
                className="w-full h-full min-h-[480px] grayscale-[20%]"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                data-testid="contact-map"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
